import { getUserApiKey, isLoggedIn, logoutCallback } from "../app/util/helpers";
import { API_ENDPOINT_BASE_URL, API_ENDPOINT_BASE_URL_2 } from "../app/util/constants";
import { getEksConfig } from "../app/util/apiConfig";

export default function setupAxios(axios, store) {
  localStorage.setItem("app_env", `${process.env.REACT_APP_ENV}`);
  axios.interceptors.request.use(
    (config) => {
      const {
        auth: { authToken },
      } = store.getState();
      if (authToken) {
        config.withCredentials = true;
        config.headers.Authorization = getUserApiKey();
        if (!(config.data instanceof FormData)) {
          config.headers["Content-Type"] = "application/json";
        }
        config.headers.jwtAuthorization = authToken;
      }
      const { isEksEnabled, eksEndpoints } = getEksConfig(store);
      if (isEksEnabled && eksEndpoints.length > 0) {
        const isSecondary = eksEndpoints.some(endpoint =>
          config.url && config.url.includes(endpoint)
        );
        if (isSecondary) {
          config.url = config.url.replace(API_ENDPOINT_BASE_URL, API_ENDPOINT_BASE_URL_2);
        }
      }
      return config;
    },
    (err) => Promise.reject(err)
  );

  const { dispatch } = store;

  axios.interceptors.response.use(
    function(response) {
      return response;
    },
    function(error) {
      if (
        error &&
        error.response &&
        401 === error.response.status &&
        isLoggedIn()
      ) {
        if(error?.response?.data?.error?.message == 'Invalid token') {
          logoutCallback(true);
        }
      } else {
        return Promise.reject(error);
      }
    }
  );
}
